module.exports = __webpack_public_path__ + "img/icon-visa.07f26621.svg";